// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federmaterial/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federmaterialDE: PageEntry = {
  id: "post.federmaterial",
  locale: "de",
  slug: "federmaterial",
  seo: {
    title: "Glossar: Federmaterial einfach erklärt | Dietz GmbH",
    description: "Das Federmaterial bezeichnet das Material, aus dem eine Feder hergestellt ist. Federn können aus verschiedenen Materialien wie Stahl, Edelstahl, Titan, Kunststoff oder Legierungen ",
  },
  type: "post",
  h1: "Glossar: Federmaterial einfach erklärt",
  intro: "Das Federmaterial bezeichnet das Material, aus dem eine Feder hergestellt ist. Federn können aus verschiedenen Materialien wie Stahl, Edelstahl, Titan, Kunststoff oder Legierungen bestehen. Die Wahl des geeigneten Federmaterials hängt von den spezifischen Anforderungen der Anwendung ab, einschließlich der benötigten Festigkeit, Elastizität, Korrosionsbeständigkeit und thermischen Stabilität. Die Auswahl des richtigen Federmaterials ist entscheidend, um sicherzustellen, dass die Feder den Belastungen in ihrer Umgebung standhalten und ihre Funktion über einen langen Zeitraum aufrechterhalten kann.",
  blocks: [

  ],
};
